import { authnClient } from '@frontend/auth';
import { useEffect, useState } from 'react';

export const useOIDCSignIn = (enabled: boolean) => {
  const [message, setMessage] = useState<string>('');
  const [redirecting, setRedirecting] = useState(false);

  const signIn = () => {
    setMessage('');
    setRedirecting(true);
    authnClient.signIn().catch((err: any) => {
      setMessage(err.message);
      setRedirecting(false);
    });
  };

  useEffect(() => {
    if (enabled) {
      signIn();
    }
  }, [enabled]);

  return {
    redirecting,
    message,
  };
};

export const OIDCSignIn = ({ message }: { message?: string }) => {
  return (
    <>
      {
        message !== '' ? <div>{message}</div> : null
        // <ContentLoader show message={t('You are being redirected to the login page')} />
      }
    </>
  );
};
